import monsterVideoBg from '@/assets/video/monster_uhd.mp4';
import monsterVideoPoster from '@/assets/video/monster_uhd_poster.jpg';
import briefVideoBg from '@/assets/video/brief_uhd.mp4';
import briefVideoPoster from '@/assets/video/brief_uhd_poster.jpg';
import endVideoBg from '@/assets/video/end_uhd.mp4';
import endVideoPoster from '@/assets/video/end_uhd_poster.jpg';
import shareVideoBg from '@/assets/video/share_uhd.mp4';
import shareVideoPoster from '@/assets/video/share_uhd_poster.jpg';
import oracleAvatarVideo from '@/assets/video/oracle_avatar_348x348.mp4';
import oracleAvatarFullVideoPoster from '@/assets/video/oracle_avatar_348x348_poster.jpg';
import bgCardVideo from '@/assets/video/bg_card_video.mp4';
import bgCardVideoPoster from '@/assets/video/bg_card_video_poster.jpg';
import keeperAvatar from '@/assets/img/k8s_avatar.png';
import monsterAvatar from '@/assets/img/chaos_monster_avatar.png';
import masterAvatar from '@/assets/img/master_avatar.png';
import oracleAvatar from '@/assets/img/oracle_new_avatar.png';
import keeperCardBg from '@/assets/img/k8s_keeper_card_bg.png';
import monsterCardBg from '@/assets/img/chaos_card_bg.png';
import masterCardBg from '@/assets/img/master_card_bg.png';
import oracleCardBg from '@/assets/img/yaml_card_bg.png';

export const S3_FILES = {
    MONSTER_VIDEO: monsterVideoBg,
    MONSTER_VIDEO_POSTER: monsterVideoPoster,
    BRIEF_VIDEO: briefVideoBg,
    BRIEF_VIDEO_POSTER: briefVideoPoster,
    END_VIDEO: endVideoBg,
    END_VIDEO_POSTER: endVideoPoster,
    SHARE_VIDEO: shareVideoBg,
    SHARE_VIDEO_POSTER: shareVideoPoster,
    YAML_HELPER_VIDEO: oracleAvatarVideo,
    YAML_HELPER_VIDEO_POSTER: oracleAvatarFullVideoPoster,
    CHARACTER_CARD_BG_VIDEO: bgCardVideo,
    CHARACTER_CARD_BG_VIDEO_POSTER: bgCardVideoPoster,
    KEEPER_CARD_AVATAR: keeperAvatar,
    MONSTER_CARD_AVATAR: monsterAvatar,
    MASTER_CARD_AVATAR: masterAvatar,
    ORACLE_CARD_AVATAR: oracleAvatar,
    KEEPER_CARD_BG: keeperCardBg,
    MONSTER_CARD_BG: monsterCardBg,
    MASTER_CARD_BG: masterCardBg,
    ORACLE_CARD_BG: oracleCardBg,
} as const;
